import React from 'react'
import SearchComp from '../components/search/SearchComp'

const Search = () => {
  return (
    <>
    <div  >
        <SearchComp/> 
  
        </div>
    </>
  )
}

export default Search